import * as React from "react";
function SvgChevronRight(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.707 12.707l-8 8-1.414-1.414L14.586 12 7.293 4.707l1.414-1.414 8 8a1 1 0 010 1.414z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgChevronRight);
export default ForwardRef;
